import { E_AI_TAGGING_TOUR_STATUS } from '@/domains/user-guide/ai-tagging-tour/enums';
import { StorageService } from '@/infrastructure/utils/util-services/local-storage/type/local-storage-service.interface';
import { injectService } from '@/inversify.config';
import { useRaven } from '@/presentation/composables/use-raven';
import { createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
const LOCAL_STORAGE_TOUR_AI_TAGGING_SKIP_KEY = 'LOCAL_STORAGE_TOUR_AI_TAGGING_SKIP_KEY';
export const useAiTaggingTour = createSharedComposable(() => {
    const storageService = injectService(StorageService);
    const route = useRoute();
    const router = useRouter();
    const { rvTrack } = useRaven();
    const aiTaggingTourStatus = computed(() => {
        return route.query.ai_tagging_tour_status;
    });
    const finishTour = () => {
        router.replace({
            query: {
                ...route.query,
                ai_tagging_tour_status: E_AI_TAGGING_TOUR_STATUS.FINISHED,
            },
        });
        rvTrack('Finish AI Tagging Tour');
    };
    const reTryTour = () => {
        router.replace({
            query: {
                ...route.query,
                ai_tagging_tour_status: E_AI_TAGGING_TOUR_STATUS.PROCESS,
            },
        });
        rvTrack('Retry AI Tagging Tour');
    };
    const exitTour = () => {
        router.replace({
            query: {
                ..._.omit(route.query, 'ai_tagging_tour_status'),
            },
        });
    };
    const setSkipSymbolToLocal = () => {
        storageService.setItem(LOCAL_STORAGE_TOUR_AI_TAGGING_SKIP_KEY, true);
    };
    const getUserHadSkipAiTaggingTour = () => {
        return storageService.getItem(LOCAL_STORAGE_TOUR_AI_TAGGING_SKIP_KEY);
    };
    return {
        aiTaggingTourStatus,
        finishTour,
        reTryTour,
        exitTour,
        getUserHadSkipAiTaggingTour,
        setSkipSymbolToLocal,
    };
});
